import { useState, useEffect } from 'react'

interface PendingVerificationData {
  email: string
  name: string
  document: string
  document_type: 'CPF' | 'CNPJ'
  type: 'individual' | 'company'
  phone: string
  timestamp: number
}

export const usePendingVerification = () => {
  const [pendingData, setPendingData] = useState<PendingVerificationData | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const checkPendingVerification = () => {
      try {
        const stored = localStorage.getItem('pending_verification')
        if (stored) {
          const data = JSON.parse(stored) as PendingVerificationData
          
          // Verificar se os dados não são muito antigos (24 horas)
          const isExpired = Date.now() - data.timestamp > 24 * 60 * 60 * 1000
          
          if (!isExpired) {
            setPendingData(data)
          } else {
            // Limpar dados expirados
            localStorage.removeItem('pending_verification')
            localStorage.removeItem('verification_token')
            localStorage.removeItem('user_id')
          }
        }
      } catch (error) {
        console.error('Erro ao verificar verificação pendente:', error)
        // Limpar dados corrompidos
        localStorage.removeItem('pending_verification')
        localStorage.removeItem('verification_token')
        localStorage.removeItem('user_id')
      } finally {
        setIsLoading(false)
      }
    }

    checkPendingVerification()
  }, [])

  const clearPendingVerification = () => {
    localStorage.removeItem('pending_verification')
    localStorage.removeItem('verification_token')
    localStorage.removeItem('user_id')
    setPendingData(null)
  }

  return {
    pendingData,
    isLoading,
    clearPendingVerification,
    hasPendingVerification: !!pendingData
  }
}
